import React from 'react'
import { Controller } from 'react-hook-form'
import { IconButton } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import PropTypes from 'prop-types'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'
import { useDetailStyles } from '../../TagDetails'

const KdpListFields = ({ fields, form, append, remove, editing }) => {
  const classes = useDetailStyles()
  return (
    <div className={classes.kvpList}>
      {fields.map((pair, index) => (
        <div key={index} className='flex gap-2'>
          <Controller
            control={form.control}
            name={`options.${index}.label`}
            render={(f) => (
              <SydLabel label='Option'>
                <SydInput
                  {...f.field}
                  disabled={!editing}
                  placeholder='label'
                />
              </SydLabel>
            )}
          />
          <Controller
            control={form.control}
            name={`options.${index}.value`}
            render={(f) => (
              <SydLabel label='Value'>
                <SydInput
                  {...f.field}
                  disabled={!editing}
                  placeholder='label'
                />
              </SydLabel>
            )}
          />
          {editing && (index === 0 ? (
            <div className={classes.inputBtnContainer}>
              <IconButton
                icon='plus'
                onClick={() => append({ label: '', value: '' })}
              >
                <AddIcon />
              </IconButton>
            </div>
          ) : (
            <div className={classes.inputBtnContainer}>
              <IconButton
                icon='minus'
                onClick={() => remove(index)}
              >
                <RemoveIcon />
              </IconButton>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

KdpListFields.propTypes = {
  editing: PropTypes.bool,
  fields: PropTypes.array,
  form: PropTypes.object,
  append: PropTypes.func,
  remove: PropTypes.func
}

export default KdpListFields
